import { FormGroupState } from "ngrx-forms";
import { EmployeeModel } from "src/app/model/employee.model";

export interface INewEmployeeRequestListViewState {
  list: EmployeeModel[];
  filter: FormGroupState<NewEmployeeRequestListViewFilter>;
  hasNewEmployee: boolean;
}

export class NewEmployeeRequestListViewFilter {
  q: string = '';
  currentPage: number = 0;
}
